
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/profile",
      function () {
        return require("private-next-pages/my-account/profile/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/profile"])
      });
    }
  